module.exports = __webpack_public_path__ + "static/img/fish31.be65cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish31.png
// module id = oLVC
// module chunks = 0